module.exports = __webpack_public_path__ + "img/zhanghaoguanli.cdc22cb0.png";